import React, { useState } from "react";
import { Layout, Menu, Card, Avatar, message } from "antd";
import { supabase } from "../../config/supabaseClient";
import { useAuth } from "../../config/AuthContext";
import { useNavigate } from "react-router-dom";

const { Sider, Content } = Layout;

const TeacherDashboard = () => {
  const { session, profile } = useAuth();
  const teacherName = profile?.name || session?.user?.email || "Teacher";
  const teacherEmail = session?.user?.email || "";
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
      message.success("Logged out successfully!");
      navigate("/");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <Layout className="min-h-screen bg-background animate-fade-in">
      <Sider
        width={250}
        className={`bg-gradient-to-b from-primary to-foreground text-white ${
          visible ? "block" : "hidden"
        } md:block fixed md:relative z-50 shadow-lg animate-fade-in`}
        breakpoint="md"
        collapsedWidth="0"
        onBreakpoint={(broken) => setVisible(!broken)}
      >
        <div className="p-6 text-center">
          <Avatar
            size={80}
            className="mb-4 shadow-md border-2 border-gray-200"
            src="https://www.w3schools.com/w3images/avatar2.png"
          />
          <h1 className="text-lg font-bold">{teacherName}</h1>
          <p className="text-gray-400">{teacherEmail}</p>
        </div>
        <Menu
          theme="none"
          mode="inline"
          className="mt-4 rounded-md"
          items={[
            {
              label: (
                <button
                  onClick={handleLogout}
                  className="w-full text-white text-center bg-red-600 hover:bg-red-500 rounded-md py-2 font-medium"
                >
                  Logout
                </button>
              ),
              key: "logout",
            },
          ]}
        />
      </Sider>

      <Layout>
        <Content className="p-6">
          <Card className="rounded-lg shadow-lg bg-white">
            <h2 className="text-2xl font-bold text-gray-800">Welcome, {teacherName}!</h2>
            <p className="text-gray-500 mt-2">
              Your teacher dashboard is being set up. Check back soon for your courses and
              student insights.
            </p>
          </Card>
        </Content>
      </Layout>
    </Layout>
  );
};

export default TeacherDashboard;
